// extracted by mini-css-extract-plugin
module.exports = {"UsageScenariosB":"UsageScenariosB_UsageScenariosB__KTXq2"};